"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = nullThrows;
function nullThrows(x, error) {
    if (typeof x === "undefined" || x === null) {
        throw error instanceof Error ? error : new Error(error);
    }
    return x;
}
//# sourceMappingURL=nullThrows.js.map